export default class FormBo {
    vorgangsnumer?: string;
}